import type { Input } from '@builder.io/sdk';

const contentEditorFields = [
  {
    name: 'eyebrow',
    type: 'text',
  },
  {
    name: 'heading',
    type: 'text',
  },
  {
    name: 'description',
    type: 'text',
    helperText: 'For usage with the listing page',
  },
  {
    name: 'firstPublished',
    type: 'timestamp',
  },
  {
    name: 'slug',
    type: 'text',
  },
  {
    name: 'body',
    type: 'richText',
  },
] as const satisfies DeepReadonly<Input[]>;

const contentEditorConfig = {
  name: 'Content Editor',
  inputs: contentEditorFields,
};

export type ContentEditorProps = GenerateBuilder<typeof contentEditorFields>;

export default contentEditorConfig;
